import LandingPage from './LandingPage';


export default { LandingPage };



// WEBPACK FOOTER //
// ./src/components/Pages/Family/index.js